<template>
  <div class="main-container">
    <div class="sidebar-container">
      <div class="logo-container">
        <img
          alt="Hook Theory"
          class="logo"
          src="./assets/Output_logo_black_color.png"
        />
        <span class="logo-text">Progression</span>
      </div>
      <!-- Sidebar content goes here -->
      <button @click="toggleChords">
    <i :class="chordsShown ? 'fa fa-times-circle' : 'fa fa-list-ul'"></i>
    {{ chordsShown ? 'Clear Chords' : 'Get All Chords' }}
  </button>
      <button @click="togglePiano">
        <i class="fa-solid fa-circle-play"></i> Toggle Piano
      </button>
      <button
        v-if="chordStore.chordProgression.length > 0"
        @click="toggleSongs"
      >
        <i class="fa-solid fa-headphones"></i> Show similar songs
      </button>
      <MidiExporter :chordProgression="chordIdList" ref="midiExporter" />
      <!-- Add more buttons or content as needed -->
    </div>

    <div class="progression-container">
      <div class="progression">
        <button @click="clearProgression" class="clear-button">
          <i class="fa fa-eraser"></i>
        </button>
        <h3>Chord Progression</h3>
        <div class="chord-container">
          <div
            v-if="
              chordStore.chordProgression !== null &&
              chordStore.chordProgression.length > 0
            "
          >
            <div
              v-for="(chord, index) in chordStore.chordProgression"
              :key="index"
              class="chord-circle"
              @click="playChord(chord)"
            >
              <span v-html="chord.chordHTML"></span>
              <i
                class="fa-regular fa-trash-can remove-icon"
                v-if="index === chordStore.chordProgression.length - 1"
                @click.stop="removeLastChord(index)"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chord-recommendations">
      <div class="outer-container">
        <div class="cards-grid" v-if="!loadingChords">
          <div
            v-for="(chord, index) in chordStore.compatibleChords"
            :key="index"
            class="card"
          >
            <div class="card-content" @click="handlePlayChord(chord.chord_ID)">
              <i class="fa-solid fa-music"></i>
              <div class="chord-info">
                <!-- <div class="chord-id">{{ chord.chord_ID }}</div> -->
                <div class="chord-html" v-html="chord.chord_HTML"></div>
              </div>
              <div class="chord-probability">
                {{ (chord.probability * 100).toFixed(2) }}%
              </div>
              <button
                @click="addToProgression(chord.chord_ID, chord.chord_HTML)"
                class="add-btn"
              >
                <i class="fa fa-plus-circle"></i> Add
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <img src="./assets/loading01.gif" alt="Loading..." />
        </div>
      </div>
    </div>
  </div>
  <PianoPlayer
    ref="pianoPlayer"
    v-if="showPiano"
    @request-play-chord="handlePlayChord"
  ></PianoPlayer>
  <SongsView v-if="showSongs && chordStore.chordProgression.length > 0">
  </SongsView>
</template>

<script>
import { chordStore } from "./store/chordStore";
import { toRefs, watch, computed } from "vue";
import {
  getAllChords,
  getCompatibleChords,
  clearCompatibleChords,
  addToProgression,
  getSimilarSongs,
} from "@/services/chordService";
import PianoPlayer from "./components/PianoPlayer";
import MidiExporter from "./components/MidiExporter";
import SongsView from "./components/SongsView.vue";

export default {
  name: "App",
  components: {
    PianoPlayer,
    MidiExporter,
    SongsView,
  },
  data() {
    return {
      showPiano: true,
      showSongs: true,
      chordsShown: false, 
    };
  },
  methods: {
    toggleChords() {
      if (this.chordsShown) {
        this.clearCompatibleChords();
      } else {
        this.getAllChords();
      }
      this.chordsShown = !this.chordsShown;
    },
    togglePiano() {
      this.showPiano = !this.showPiano; // Toggle the visibility of the piano
    },
    toggleSongs() {
    // This will toggle the state of showSongs in your chordStore
    chordStore.showSongs = !chordStore.showSongs;
    if (chordStore.chordProgression.length > 0) {
       
      this.showModal = chordStore.showSongs;
    }
  },
    playChord(chord) {
      console.log("Chord clicked:", chord);
      // Extract chordID from the chord object
      const chordID = chord.chordID;
      if (this.showPiano && this.$refs.pianoPlayer) {
        const chordDetails = this.$refs.pianoPlayer.chords.find(
          (ch) => ch.id === chordID
        );
        if (chordDetails && chordDetails.notes) {
          this.$refs.pianoPlayer.playChord(chordDetails.notes);
        } else {
          console.error("Chord not found:", chordID);
        }
      }
    },
    handlePlayChord(chordId) {
      const chord = this.$refs.pianoPlayer.chords.find(
        (ch) => ch.id === chordId
      );
      if (chord && chord.notes) {
        this.$refs.pianoPlayer.playChord(chord.notes);
      } else {
        console.error("Chord not found:", chordId);
      }
    },
    dragStart(event, chord) {
      event.dataTransfer.setData("chord", JSON.stringify(chord));
    },
    allowDrop(event) {
      event.preventDefault();
    },
    drop(event, slotIndex) {
      event.preventDefault();
      const chord = JSON.parse(event.dataTransfer.getData("chord"));
      this.$refs.pianoPlayerComponent.addChordToSlot(slotIndex, chord);
    },
  },
  mounted() {
    document.title = "Theory Sandbox";
  },
  setup() {
    const chordIdList = computed(() =>
      chordStore.chordProgression.map((chord) => chord.chordID)
    );
    const { chordProgression, compatibleChords, loadingChords } =
      toRefs(chordStore);
    const logProgression = async () => {
      console.log(chordStore.chordProgression);
    };

    const clearProgression = async () => {
      chordStore.chordProgression = [];
      compatibleChords.value = [];
    };

    const removeLastChord = async () => {
      chordStore.chordProgression.pop();
      const chordIdList = chordStore.chordProgression
        .map((chord) => chord.chordID)
        .join(",");
      console.log(chordIdList);
      // Update compatible chords list after a chord is removed
      await getCompatibleChords(chordIdList);
    };

    watch(chordProgression);
    console.log(chordStore.value);
    return {
      ...toRefs(chordStore),
      clearProgression,
      chordStore,
      getAllChords,
      getCompatibleChords,
      clearCompatibleChords,
      addToProgression,
      logProgression,
      loadingChords,
      removeLastChord,
      MidiExporter,
      chordIdList,
      getSimilarSongs,
    };
  },
};
</script>

<style scoped>
@import "@/styles.css";
</style>
